import {HTTP} from '../../../../services/api-service.js';
import commonObj from '../../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'BusinessEntity';

const businessEntityStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "",
            orderBy: "",
            take: 20,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
        getBusinessEntityList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/businessEntity/getinvlist', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        saveBusinessEntity({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/businessEntity/save', JSON.stringify({header: param.header, details: param.details, misc: param.misc, delivery:param.delivery})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        deleteBusinessEntity({commit},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/businessEntity/delete', JSON.stringify({header: param.header})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, {responseType : 'blob'}).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default businessEntityStore;